import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BLOG_URL, TRUST_CENTER_URL } from '@app/config';

interface NavItem {
  href: string;
  label: string;
  target: '_blank' | '_self';
}

interface NavGroup {
  label: string;
  items: NavItem[];
}

interface NavColumn {
  items: NavGroup[];
}

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  protected readonly currentYear = new Date().getFullYear();
  protected readonly navColumns: NavColumn[] = [
    {
      items: [
        {
          label: 'Product',
          items: [
            {
              href: '/live-updates/',
              label: 'Live Updates',
              target: '_self',
            },
            {
              href: '/native-builds/',
              label: 'Native Builds',
              target: '_self',
            },
            {
              href: '/app-store-publishing/',
              label: 'App Store Publishing',
              target: '_self',
            },
          ],
        },
        {
          label: 'Developer',
          items: [
            {
              href: 'https://capawesome.io/cloud/',
              label: 'Documentation',
              target: '_blank',
            },
            {
              href: 'https://capawesome.io/cloud/api',
              label: 'API Reference',
              target: '_blank',
            },
            {
              href: `${BLOG_URL}category/cloud/`,
              label: 'Guides',
              target: '_blank',
            },
            {
              href: 'https://github.com/capawesome-team/',
              label: 'GitHub',
              target: '_blank',
            },
            {
              href: 'https://status.capawesome.io/',
              label: 'Status',
              target: '_blank',
            },
            {
              href: '/trust',
              label: 'Trust & Security',
              target: '_self',
            },
          ],
        },
      ],
    },
    {
      items: [
        {
          label: 'Follow us',
          items: [
            {
              href: 'https://x.com/capawesomeio',
              label: 'X',
              target: '_blank',
            },
            {
              href: 'https://github.com/capawesome-team/',
              label: 'GitHub',
              target: '_blank',
            },
            {
              href: 'https://www.linkedin.com/company/capawesome',
              label: 'LinkedIn',
              target: '_blank',
            },
            {
              href: 'https://www.youtube.com/@capawesomeio',
              label: 'YouTube',
              target: '_blank',
            },
          ],
        },
      ],
    },
    {
      items: [
        {
          label: 'Compare',
          items: [
            {
              href: '/compare/capgo/',
              label: 'Capgo',
              target: '_self',
            },
            {
              href: '/compare/ionic-appflow/',
              label: 'Ionic Appflow',
              target: '_self',
            },
          ],
        },
        {
          label: 'Partners',
          items: [
            {
              href: '/partners/openforge/',
              label: 'OpenForge',
              target: '_self',
            },
          ],
        },
        {
          label: 'Tools',
          items: [
            {
              href: '/tools/android-keystore-generator/',
              label: 'Android Keystore Generator',
              target: '_self',
            },
            {
              href: '/tools/ios-certificate-generator/',
              label: 'iOS Certificate Generator',
              target: '_self',
            },
            {
              href: '/tools/ios-udid-finder/',
              label: 'iOS UDID Finder',
              target: '_self',
            },
          ],
        },
      ],
    },
    {
      items: [
        {
          label: 'Company',
          items: [
            { href: BLOG_URL, label: 'Blog', target: '_blank' },
            { href: '/careers/', label: 'Careers', target: '_self' },
            { href: '/contact/', label: 'Contact', target: '_self' },
            { href: '/newsletter/', label: 'Newsletter', target: '_self' },
            { href: '/partners/', label: 'Partners', target: '_self' },
            { href: '/pricing/', label: 'Pricing', target: '_self' },
            { href: '/enterprise/', label: 'Enterprise', target: '_self' },
            { href: '/trust/', label: 'Security', target: '_self' },
            {
              href: 'https://capawesome.io/sla/',
              label: 'Service Level Agreement',
              target: '_blank',
            },
            {
              href: TRUST_CENTER_URL,
              label: 'Trust Center',
              target: '_blank',
            },
            {
              href: 'https://capawesome.io/subprocessors/',
              label: 'Subprocessor',
              target: '_blank',
            },
            {
              href: 'https://capawesome.io/privacy/',
              label: 'Privacy Policy',
              target: '_blank',
            },
            {
              href: 'https://capawesome.io/terms/',
              label: 'Terms',
              target: '_blank',
            },
            {
              href: 'https://capawesome.io/legal/',
              label: 'Legal',
              target: '_blank',
            },
          ],
        },
      ],
    },
  ];
  protected readonly trustCenterUrl = TRUST_CENTER_URL;
}
